import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setSelectedPostFilterWithUpdate } from '../../../../../redux/actions/filterActions';
import styles from './index.module.scss';

/**
 * Карточка коллекции. Используется внутри CollectionLine.
 * item — публикация из tab_list (с content, template) или элемент block_content.
 * Клик обрабатывается как в news_line: навигация по шаблону, для post — установка фильтра.
 */
const CollectionCard = ({
  item,
  path_to_folder = null,
  onClick = null,
  hasDragged = false,
  parentTab = null,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const dataFromPublicationContent = React.useMemo(() => {
    if (!item?.content || typeof item.content !== 'string') return null;
    try {
      const parsed = JSON.parse(item.content);
      const blocks = Array.isArray(parsed) ? parsed : [];
      const firstBlock = blocks[0];
      const blockContent = firstBlock?.block_content;
      if (!Array.isArray(blockContent)) return null;
      const titleItem = blockContent.find(
        (c) =>
          (c?.content_type === 'text' || c?.cotent_type === 'text') && (c?.content_tag === 'title' || c?.cotent_tag === 'title')
      ) || blockContent.find(
        (c) => c?.content_tag === 'item_name' || c?.cotent_tag === 'item_name'
      );
      const imgItem = blockContent.find(
        (c) => (c?.content_type === 'img' || c?.cotent_type === 'img') && c?.img_name && String(c.img_name).toLowerCase() !== 'none'
      );
      const title = titleItem?.content_text ?? titleItem?.cotent_text ?? null;
      const imgName = imgItem?.img_name
        ? (typeof imgItem.img_name === 'string' ? imgItem.img_name.replace(/\\/g, '/').split('/').pop() : imgItem.img_name)
        : null;
      return { title, imgName };
    } catch {
      return null;
    }
  }, [item?.content]);

  const block0 = item?.block_content?.[0];
  const content_text = item?.content_text ?? item?.cotent_text ?? block0?.content_text ?? block0?.cotent_text ?? null;
  const links_names = item?.links_names ?? block0?.links_names ?? null;

  const title = dataFromPublicationContent?.title
    || content_text
    || item?.title
    || item?.show_name
    || item?.eng_name
    || 'Коллекция';
  const rawImageName = dataFromPublicationContent?.imgName
    ?? item?.img_name
    ?? item?.image
    ?? (item?.block_content && item.block_content.find((c) => c.img_name)?.img_name);
  const imageName = rawImageName && String(rawImageName).toLowerCase() !== 'none' ? rawImageName : null;
  const imageSrc = path_to_folder && imageName
    ? path_to_folder + (typeof imageName === 'string' ? imageName.replace(/\\/g, '/').split('/').pop() : imageName)
    : null;

  const handleClick = (e) => {
    if (hasDragged) return;

    const templateName = item?.template?.template_name;
    const engName = item?.eng_name || item?.blank_name;
    const resolvedParentTab = parentTab ?? item?.parent_tab;

    if (resolvedParentTab && engName) {
      if (templateName === 'publication_v1') {
        const url = resolvedParentTab === 'main_tab' ? '/' : `/${resolvedParentTab}/${engName}`;
        navigate(url);
      } else if (templateName === 'publication_v2') {
        const url = resolvedParentTab === 'main_tab' ? '/' : `/${resolvedParentTab}/${engName}`;
        navigate(url);
      } else if (templateName === 'Publication_1') {
        const url = resolvedParentTab === 'main_tab' ? '/' : `/${resolvedParentTab}/${engName}`;
        navigate(url);
      } else if (templateName === 'post') {
        const url = resolvedParentTab === 'main_tab' ? '/' : `/${resolvedParentTab}`;
        navigate(url);
        setTimeout(() => {
          dispatch(setSelectedPostFilterWithUpdate(engName));
        }, 100);
      } else if (templateName === 'item' || templateName === 'item_data_v1') {
        const url = resolvedParentTab === 'main_tab' ? `/${engName}` : `/${resolvedParentTab}/${engName}`;
        navigate(url);
      }
    }

    if (onClick) onClick(item);
  };

  if (!item) return null;

  return (
    <div
      className={styles.collectionCard}
      onClick={handleClick}
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
      onKeyDown={onClick ? (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); handleClick(e); } } : undefined}>
      {imageSrc && (
        <div className={styles.cardImageWrap}>
          <img src={imageSrc} alt="" className={styles.cardImage} />
        </div>
      )}
      <div className={styles.cardContent}>
        <h3 className={styles.cardTitle}>{title}</h3>
      </div>
    </div>
  );
};

export default CollectionCard;
